import { Validator } from '@vista-digital/validator';
import { defaultFilmSynopsisConfig, filmSynopsisConfigValidator } from './config';
import { defaultFilmSynopsisDisplayText, filmSynopsisDisplayTextValidator } from './display-text';
export const defaultFilmSynopsisProps = {
    displayText: defaultFilmSynopsisDisplayText,
    config: defaultFilmSynopsisConfig
};
export const filmSynopsisPropsValidator = Validator.object({
    displayText: filmSynopsisDisplayTextValidator,
    config: filmSynopsisConfigValidator
});
